import { weightUnitEnumFromOrdinal } from './weight-unit-enum-from-ordinal-service';
import { WeightUnit } from '../../../enums/weight-unit';

export const getWeightUnitEnum = (value) => {
  const defaultWeightUnitEnum = WeightUnit.Ounces;
  if (value === null || value === undefined) {
    return defaultWeightUnitEnum;
  }

  const parsedValue = Number.parseFloat(value);
  if (Number.isInteger(parsedValue)) {
    return weightUnitEnumFromOrdinal(parsedValue);
  }

  const normalizedValue = value.toLowerCase();
  const matchedKey = Object.keys(WeightUnit).find((k) => k.toLowerCase() === normalizedValue);
  return matchedKey ? WeightUnit[matchedKey] : defaultWeightUnitEnum;
};
